export enum PurchasePermitsEnum {
  Available = 1,
  NotAvailable = 2,
  Question = 3,
}
